export default __webpack_public_path__ + "static/media/ag.cd5f7986.svg";